import AsyncStorage from '@react-native-async-storage/async-storage';
import * as _ from 'lodash';
import { unionBy, uniq, uniqBy } from 'lodash';

const Reducer = (state, action) => {
    switch (action.type) {
        case 'SET_ORDER_GROUP':
            return {
                ...state,
                order_group: action.payload
            };
        case 'SET_ORDER_GROUP_ITEMS':
            let order_items = []
            if(action.payload) {
                order_items = action.payload.map(item => {
                    if(item.product && item.product.sellers) {
                        let arr = []
                        for(var i in item.product.sellers) {
                            if(item.product.sellers[i].status==='active') {
                                arr.push(item.product.sellers[i])
                            }
                        }
                        if (arr.length) {
                            item.product['pricetag'] = {
                                mpu: arr[0].mpu,
                                price: arr[0].price,
                            }
                        // } else {
                        //     item.product['pricetag'] = {
                        //         mpu: item.product.mpu,
                        //         price: item.product.price
                        //     }
                            return item
                        }
                        return null
                    // } else {
                    //     item.product['pricetag'] = {
                    //         mpu: item.product.mpu,
                    //         price: item.product.price
                    //     }
                    }
                    return null
                });
            }
            order_items = order_items.filter(item => item !== null)

            return {
                ...state,
                order_group_items: order_items
            };
        case 'ADD_ORDER_GROUP_ITEM':
            let added = Array.from(state.order_group_items || [])
            added.unshift(action.payload)
            AsyncStorage.setItem('orderGroupItems', JSON.stringify(added))
            return {
                ...state,
                order_group_items: added
            };
        case 'UPDATE_ORDER_GROUP_ITEM':
            let update = state.order_group_items.map(item => {
                if (item._id == action.payload._id) {
                    item['quantity'] = action.payload.quantity
                    item['amount'] = action.payload.amount
                    return item
                }
                return item
            })
            AsyncStorage.setItem('orderGroupItems', JSON.stringify(update))
            return {
                ...state,
                order_group_items: update
            };
        case 'UPSERT_ORDER_GROUP_ITEM':
            let _upsert = unionBy([action.payload], Array.from(state.order_group_items), '_id')
            
            AsyncStorage.setItem('orderGroupItems', JSON.stringify(_upsert))
            return {
                ...state,
                order_group_items: _upsert
            };
        case 'REMOVE_ORDER_GROUP_ITEM':
            let seived = state.order_group_items.filter(item => item._id !== action.payload)
            AsyncStorage.setItem('orderGroupItems', JSON.stringify(seived))
            return {
                ...state,
                order_group_items: seived
            };
        case 'SET_ERROR':
            return {
                ...state,
                error: action.payload
            };
        case 'CLEAR_ALL':
            AsyncStorage.removeItem('orderGroup')
            AsyncStorage.removeItem('orderGroupItems')
            
            return {
                ...state,
                order_group: null,
                order_group_items: [],
            }
        case 'SET_DELIVERY':
            return {
                ...state,
                delivery: action.payload
            }
        default:
            return state;
    }
};

export default Reducer;